import { atom, selector } from 'recoil'
import { BeListApiGetAllTags } from 'Api/BeListApi'
import {
  STORE_KEY_ID_LIST,
  ABTEST_LIST_STATUS_ALL,
  ABTEST_LIST_TYPE_ALL,
  DEFAULT_PAGE_SIZE
} from 'Constants'
import { storeGet } from 'Helpers/localStorage'

export const searchState = atom({
  key: 'AbTestListSearchState',
  default: {
    searchText: '',
    filterTags: [],
    filterStatus: ABTEST_LIST_STATUS_ALL,
    filterType: ABTEST_LIST_TYPE_ALL,
    filterMessages: [],
    filterMessagesSelected: new Map(),
    orderBy: 'LastModificationDate', // 'LastUpdated',
    orderDesc: true,
    searchParams: {}
  }
})

export const paginationState = atom({
  key: 'AbTestListPaginationState',
  default: {
    pageNum: 1,
    pageSize: DEFAULT_PAGE_SIZE,
    totalItems: 0
  }
})

export const tagsState = selector({
  key: 'AbTestListTagsState',
  get: ({ get }) => {
    const idList = parseInt(storeGet(STORE_KEY_ID_LIST))
    return BeListApiGetAllTags(idList, true, false).then(res => {
      return res.Items.map(t => ({
        label: t.Name,
        value: t.Id
      }))
    })
  }
})

export const messagesState = atom({
  key: 'AbTestListMessagesState',
  default: {
    items: [],
    count: 0,
    loading: false
  }
})
